import ApiService from "../common/apiService";
import TokenService from "../common/tokenService";
import constants from "../common/constants";

import { GET_JOB,GET_USER_JOBS,GET_JOB_LA,DOWNLOAD_JOB_DOCUMENT } from "./actions.type";
import {formatDate, jobStatusMapping} from "../common/formatting";


const JobModule = {
  state: {
    errors: null,
    token: TokenService.getToken(),
    twoFactorAuth: {
      method: null,
      completed: null
    },
    job:{},
    jobLA: {},
    jobs:[]
  },
  mutations:{
    storeJob(state,data){
      state.job = data;
    },
    storeJobLA(state,data){
      state.jobLA = data;
    },
    storeJobs(state,data){
      data.forEach((job) => {
        let job_number = {};
        let type = {};
        let status = {};
        let visit_date = {};
        let facility = {};
        let facility_id = {};
        let site = {};
        let site_id = {};
        let suburb = {};
        let state = {};
        let stage = {};


        job_number.value = job.job_number;
        job_number.link = '/job/' + job.id;
        type.value = job.type;
        status.value = job.status;
        status.type = job.status === 'In Progress' ? 'accent' : null;
        visit_date.value = formatDate(job.visit_date, constants.DD_MM_YY);
        facility.value = job.site.facility.name;
        facility_id.value = job.site.facility.facility_number;
        site.value = job.site.name;
        site_id.value = job.site.site_number;
        suburb.value = job.site.suburb;
        state.value = job.site.state;
        stage.value = job.stage;

        job.job_number = job_number;
        job.type = type;
        job.status = status;
        job.visit_date = visit_date;
        job.facility = facility;
        job.facility_id = facility_id;
        job.site = site;
        job.site_id = site_id;
        job.suburb = suburb;
        job.state = state;
        job.stage = stage;
      });

      state.jobs = data;
    }
  },
  getters: {

  },
  actions: {
    /*TODO - Job api has already been changed
     * need to jet Site details and LA info
     */
    [GET_JOB](context,payload){
      return new Promise((resolve,reject)=>{
          ApiService.get('/jobs/'+payload.job_id)
            .then(({data}) => {
              data.data[0].status = jobStatusMapping[data.data[0].status - 1];
              this.commit('storeJob', data.data);
              resolve(data)
            })
            .catch(error => {
              reject(error)
            })
        }
      );
    },
    async [GET_JOB_LA](context, payload){
      let res = {};
      await ApiService.get('/leadAssessor/'+payload.job_id)
        .then(response => {
          this.commit('storeJobLA', response.data.data);
        })
        .catch(error=>{
          res = error;
        });
      return res;
    },
    async [GET_USER_JOBS](context,payload){
      let currentRole = localStorage.getItem(constants.CURRENT_ROLE);
      let res = {};
        await ApiService.get('/jobs?role='+currentRole).then(response => {
        res = response.data;
        res.data.map(ele => {
          ele.status = jobStatusMapping[ele.status - 1];
        });
        context.commit('storeJobs',res.data)
      }).catch(error => {
        res = error;
      });
      return res;
    }
  },
};

export default JobModule;
